import React from 'react';
import IconProps from '../../icons';

const Twitter = ({ width = 24, color = 'var(--text-primary)', className = '' }: IconProps): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7663 22.5L10.4691 14.9496L3.83773 22.5H1.03223L9.22444 13.1751L1.03223 1.5H8.23518L13.2277 8.61615L19.4831 1.5H22.2886L14.4766 10.393L22.9692 22.5H15.7663ZM18.8905 20.3714H17.0018L5.04928 3.62864H6.93832L11.7254 10.3326L12.5532 11.4959L18.8905 20.3714Z'
        fill={color}
      />
    </svg>
  );
};

export default Twitter;
